export default __webpack_public_path__ + "static/media/FutureMints.9c1c435f.gif";